import { LinkOverlay, LinkBox, Box, Heading } from "@chakra-ui/react"
import React from "react"
import Card from "../../common/components/Card"
import { mapAccessToken } from "../../config/map"
import SocialImage from "../../common/components/SocialImage"
import { VideoThumbnail } from "../../media/components/VideoThumbnail"
import { getPopMediaThumb } from "../../utilities/imageUtils"
import NextLink from "next/link"
import { hasValidCoordinates } from "../../utilities/map"

const AreaCard = ({ area, isSmall }) => {
  const imageHeight = isSmall ? "100px" : "220px"
  const coordinates = area?.location?.coordinates
  // Areas can lack a real location (e.g. after their last climb is unlinked,
  // the cache clears coordinates). Only build a static satellite thumbnail when
  // the coordinates are valid; otherwise fall back to the popMedia thumb or an
  // empty object so the card renders its background instead of crashing.
  const imageObj =
    getPopMediaThumb(area) ||
    (hasValidCoordinates(area)
      ? {
          url:
            "https://api.mapbox.com/styles/v1/mapbox/satellite-v8/static/" +
            coordinates[0] +
            "," +
            coordinates[1] +
            ",16.5,0.00/500x300@2x?access_token=" +
            mapAccessToken,
        }
      : {})
  return (
    <LinkBox as="article">
      <Card variant="link" overflow="hidden">
        <Box bg={"#333"} m={-5} mb={3} height={imageHeight} overflow="hidden">
          {imageObj?.video ? (
            <VideoThumbnail videoUrl={imageObj?.video} />
          ) : (
            <SocialImage imageObj={imageObj} height="100%" width="100%" />
          )}
        </Box>
        <NextLink passHref href={`/areas/${area.slug}`}>
          <LinkOverlay>
            <Heading variant="link" as="h3" size="md" mb={0}>
              {area.name}
            </Heading>
          </LinkOverlay>
        </NextLink>
      </Card>
    </LinkBox>
  )
}

export default AreaCard
